// extracted by css-extract-rspack-plugin
export default {"cards":"B3cIx3azoa8JppKq","card":"IKjy3t7jGoI9FzSf","selected":"gCMeoB_9I4gToiBT","description":"MfXB1Zb51w8crMgu","preview":"z2IZXQHXwsAl7Vcp","illustration":"pFioabp3qogDlo8L"};